import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "./config";

export const useTenderNDAAccepted = (tenderId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => axiosInstance.post(`tenders/${tenderId}/accept-nda`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tender-detail", tenderId] });
    },
  });
};

export const useQuotationNDAAccepted = (quotationId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      axiosInstance.post(`quotations/${quotationId}/accept-nda`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["quotation-detail", quotationId],
      });
    },
  });
};
